// extracted by mini-css-extract-plugin
export default {"container":"Title-module__container--Cvea2","header":"Title-module__header--Ak2aF","expandButton":"Title-module__expandButton--Nb66P"};